/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Konsultan_Nav_DInputs */

const en_mk_sol_konsultan_nav_d = /** @type {(inputs: Mk_Sol_Konsultan_Nav_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Knowledge work that has to be traceable.`)
};

const id_mk_sol_konsultan_nav_d = /** @type {(inputs: Mk_Sol_Konsultan_Nav_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pekerjaan berbasis pengetahuan yang harus bisa ditelusuri.`)
};

/**
* | output |
* | --- |
* | "Knowledge work that has to be traceable." |
*
* @param {Mk_Sol_Konsultan_Nav_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_konsultan_nav_d = /** @type {((inputs?: Mk_Sol_Konsultan_Nav_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Konsultan_Nav_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_konsultan_nav_d(inputs)
	return en_mk_sol_konsultan_nav_d(inputs)
});